import axios from "axios";

export default {
  name: "creditcard",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getcreditcardlist(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "kartu_kredit",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createBankCC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url:
            process.env.VUE_APP_SERVICEURL + "kartu_kredit",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    editBankCC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url:
            process.env.VUE_APP_SERVICEURL + "kartu_kredit",
          data: params,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": 'application/json',
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    nonActiveCC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url:
            process.env.VUE_APP_SERVICEURL + "kartu_kredit/deactived",
          data: {
            id_user_cc: params
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": 'application/json',
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDataBankCC(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "bank_garansi",
          data: {},
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
